import React from 'react'
import PropTypes from 'prop-types'
import { get, isNil, isEmpty } from 'lodash'
import pluralize from 'pluralize'
import connectIndex from '../../lib/connectIndex'
import Component from '../common/Component'
import BulkAvCalculatorEnqueueModal from './BulkAvCalculatorEnqueueModal'
import enqueueActions from '../../actions/BenefitsSetsAvCalculatorEnqueue'
import identifierActions from '../../actions/BenefitsSetIdentifiers'

export class BulkAvCalculatorEnqueueLink extends Component {
  static propTypes = {
    queryParams: PropTypes.object.isRequired,
    productLine: PropTypes.string.isRequired,
    totalCount: PropTypes.number,
    index: PropTypes.func,
    reset: PropTypes.func,
    records: PropTypes.array,
    enqueueAvCalculator: PropTypes.func.isRequired,
    resetEnqueueAvCalculator: PropTypes.func.isRequired
  }

  static defaultProps = {
    totalCount: 0
  }

  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      result: null,
      ids: [],
      loading: false
    }
  }

  get planCount() {
    return this.props.totalCount
  }

  get bulkEnqueueModal() {
    return (
      <BulkAvCalculatorEnqueueModal
        handleClose={this.handleModalClose}
        handleEnqueue={this.handleEnqueue}
        isOpen={this.state.showModal}
        disabled={isEmpty(this.state.ids) || this.state.loading}
      >
        {this.modalMessage()}
      </BulkAvCalculatorEnqueueModal>
    )
  }

  get title() {
    return `Enqueue AV Calculator (${this.planCount})`
  }

  setIdentifiers = async () => {
    this.setState({ loading: true })
    await this.props.index({ ...this.props.queryParams, product_line: this.props.productLine })
    this.setState({ ids: this.props.records || [], loading: false })
  }

  modalMessage = () => {
    const { result, ids, loading } = this.state

    if (result) {
      return `Successfully enqueued ${pluralize('job', result.enqueued_count, true)}.`
    }

    if (loading) {
      return 'Loading plans...'
    }

    const count = ids.length

    if (count === 0) {
      return 'No plans match the current query.'
    }

    return `Enqueue AV calculator jobs for ${pluralize('plan', count, true)}?`
  }

  reset = () => {
    this.props.resetEnqueueAvCalculator()
    this.props.reset && this.props.reset()
  }

  handleOnClick = () => {
    this.reset()
    this.setState({ showModal: true, result: null, ids: [] })
    this.setIdentifiers()
  }

  handleModalClose = () => {
    this.reset()
    this.setState({ showModal: false, result: null, ids: [] })
  }

  handleEnqueue = async () => {
    const { ids } = this.state

    if (ids.length === 0) { return }

    const benefitsSetIds = ids.map((id) => parseInt(id, 10))
    const response = await this.props.enqueueAvCalculator({ benefits_set_ids: benefitsSetIds })

    if (!isNil(response.generalError)) {
      alert(response.generalError) // eslint-disable-line no-alert
    } else if (!isNil(response.resourceErrors)) {
      const errorMessage = get(response.resourceErrors, 'base') || JSON.stringify(response.resourceErrors)
      alert(errorMessage) // eslint-disable-line no-alert
    } else if (response.responseAttributes) {
      this.setState({ result: response.responseAttributes })
    }
  }

  render() {
    return (
      <>
        <button
          className="button quiet-button small"
          title={this.title}
          onClick={this.handleOnClick}
          disabled={this.planCount === 0}
        >
          {this.title}
        </button>

        {this.bulkEnqueueModal}
      </>
    )
  }
}

export default connectIndex(
  BulkAvCalculatorEnqueueLink,
  'benefitsSetIdentifiers',
  identifierActions,
  [],
  {},
  [
    { action: enqueueActions.create.main, key: 'enqueueAvCalculator' },
    { action: enqueueActions.create.reset, key: 'resetEnqueueAvCalculator' }
  ]
)
